import { useState, useEffect } from "react";
import {
  Typography,
  Form,
  message,
  Row,
  Col,
  Divider,
  Button,
  Card,
} from "antd";

import LoginSignupScreen from "./loginSignupScreen";
import { useDispatch, useSelector } from "react-redux";
import { NavLink as Link, useNavigate } from "react-router-dom";

import { resendOtpBySMSAction } from "../store/action/admin/authActions";
import "react-phone-number-input/style.css";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import { parsePhoneNumber } from "libphonenumber-js";
import { css } from "@emotion/css";
import { keyframes } from "emotion";
import { themeAction } from "../store/action/admin/themeActions";
import { langaugeTanslatorAction } from "../store/action/admin/languageTranslatorActions";
import CustomLoaderIcon from "../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon";
const { Title } = Typography;

const fadeInAndFloat = keyframes`
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const floatingAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
`;

const cardStyle = css`
  animation: ${fadeInAndFloat} 1s forwards,
    ${floatingAnimation} 3s ease-in-out infinite;
`;
function LoginPhoneCard() {
  const router = useNavigate();
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const resendOtpBySmsList = useSelector((state) => state.resendOtpBySmsList);
  const { resendOtpBySmsLoading, resendOtpBySmsError } = resendOtpBySmsList;

  const [phoneNumber, setPhoneNumber] = useState("");

  const queryParams = new URLSearchParams(window.location.search);
  const redirect_back = queryParams.get("redirect_back"); // Retrieves the "redirect_back" parameter

  const handlePhoneChange = (value) => {
    setPhoneNumber(value);
  };
  const handleSubmit = async () => {
    if (!isValidPhoneNumber(phoneNumber)) {
      alert("Invalid phone number!");
      return;
    }
    const parsedNumber = parsePhoneNumber(phoneNumber);
    try {
      const data = {
        countryCode: parsedNumber.countryCallingCode,
        phoneNo: parsedNumber.nationalNumber,
      };
      // await dispatch(themeAction(false, true));
      await dispatch(resendOtpBySMSAction(data));

      // const themeData = await dispatch(themeAction());
      // dispatch(langaugeTanslatorAction(themeData?.language || "en"));

      form.resetFields();
      sessionStorage.setItem("phoneNo", data.phoneNo);
      sessionStorage.setItem("countryCode", data.countryCode);
      router(
        "/login-via-phone-otp" +
          (redirect_back ? `?redirect_back=${redirect_back}` : "")
      );
    } catch (error) {
      message.error("Try it again!");
    }
  };

  const changingTokenList = useSelector((state) => state.changingTokenList);
  const { tokenLoginInfo, tokenLoginError } = changingTokenList;
  useEffect(() => {
    // if (tokenLoginError != null) {
    if (sharedUserInfo && sharedUserInfo?.payload) {
      let companyId =
        sharedUserInfo?.empCompanies &&
        sharedUserInfo?.empCompanies[0]?.companyId?._id;
      if (
        sharedUserInfo &&
        sharedUserInfo?.payload?.email &&
        sharedUserInfo?.payload?.type === "Kiosk" &&
        sharedUserInfo?.payload?.emailVerification === true
      ) {
        if (sharedUserInfo?.empCompanies.length !== 0) {
          router(`/kiosk/qr-code`, { replace: true });
        }
      } else if (
        sharedUserInfo &&
        sharedUserInfo?.payload?.email &&
        sharedUserInfo?.payload?.type === "user" &&
        sharedUserInfo?.payload?.emailVerification === true
      ) {
        if (
          sharedUserInfo?.empCompanies.length === 0 ||
          sharedUserInfo?.empCompanies.length > 1
        ) {
          router("/user/company/", { replace: true });
        } else {
          router(`/user/dashboard/`, { replace: true });
        }
      } else if (
        sharedUserInfo &&
        sharedUserInfo?.payload?.email &&
        sharedUserInfo?.payload?.type === "admin"
      ) {
        if (
          sharedUserInfo?.payload?.company &&
          sharedUserInfo?.payload?.planSub
        ) {
          router(`/admin/dashboard/`, { replace: true });
        } else {
          if (sharedUserInfo?.payload?.company) {
            router("/admin/onboarding");
          } else {
            router("/admin/company-setup");
          }
        }
      } else if (
        sharedUserInfo &&
        sharedUserInfo?.payload?.email &&
        sharedUserInfo?.payload?.emailVerification === true
      ) {
        router(`/manager/dashboard/`, {
          replace: true,
        });
      }
      //super admin work
    }
    // } else {
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sharedUserInfo]);
  return (
    <>
      {/* <Row
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Col span={8}>
        <Card
          
          className={cardStyle}
          style={{
            borderRadius: "32px",
            padding: "30px",
          }}
        >
          <Row>
            <Col span={24}>
              <Title level={2}>Maximize your Efficiency</Title>
              <p className="subtitle-Body-Large-Subtle subtitle-Body-Large-padding">
                Streamline your Time and Productivity
              </p>
              <Divider />
            </Col>
            <Col span={24}> */}
      <Form
        form={form}
        name="normal_login"
        className="login-form"
        layout="vertical"
        autoComplete="on"
        initialValues={{
          remember: true,
        }}
        onFinish={handleSubmit}
      >
        <Row gutter={[0, 0]} style={{ marginTop: "25px" }}>
          <Col span={24}>
            <Form.Item
              name="phone"
              // label="Phone*"
              rules={[
                {
                  required: true,
                  message: "Enter your Phone Number",
                },
              ]}
              style={{ width: "100%" }}
              className={css`
                .PhoneInputInput {
                  height: clamp(38px, 3vw, 48px) !important;
                  border-radius: 20px;
                }
              `}
            >
              <PhoneInputWithCountrySelect
                style={{ width: "100%" }}
                placeholder={"Enter phone number"}
                value={phoneNumber}
                onChange={handlePhoneChange}
                international
                defaultCountry="AE"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            {resendOtpBySmsError && (
              <p style={{ color: "red" }}>{resendOtpBySmsError}</p>
            )}
          </Col>

          <Col
            span={24}
            style={{ marginTop: 5 }}
            className={css`
              .ant-btn {
                height: 40px !important;
              }
            `}
          >
            <Form.Item noStyle>
              <Button
                type="primary"
                size="large"
                htmlType={resendOtpBySmsLoading ? "button" : "submit"}
                style={{ width: "100%", borderRadius: "20px" }}
                loading={resendOtpBySmsLoading}
              >
                Login
              </Button>
            </Form.Item>
          </Col>
          {/* <Col span={24} align="center">
            <Link to="/login">
              <Button type="text">Login via Email & Password</Button>
            </Link>
            <Link to="/login/email">
              <Button type="text">Login via Email</Button>
            </Link>
          </Col> */}
          {/* <Col span={24} align="left">
            <p
              className="spacer-medium"
              style={{ fontSize: 14, fontWeight: 600 }}
            >
              Don't have an account?{" "}
              <Link to="/signup">
                <span style={{ color: "#f47e63" }}> Register now!</span>
              </Link>
            </p>
          </Col> */}
        </Row>
      </Form>
      {/* </Col>
          </Row>
        </Card>
      </Col>
    </Row> */}
    </>
  );
}

export default LoginPhoneCard;
